import { createElement, styled, composedProps } from '@vebox/etui-system';

const DivElement = createElement('div');
const Div = styled(DivElement)(composedProps);
Div.displayName = 'Div';

export { Div };
